<app-sidebar-nav-container>
  <div class="left infopost-web">
    <div>
      <app-sidebar-nav-logo collapsedImage="/assets/svg/gasquest-logo.svg"
                            expandedImage="/assets/svg/gasquest-logo-right.svg"
                            [secondaryImage]="secondaryImage"
                            [redirectionLink]=redirectionLink
                            id="main-home-icon" >
      </app-sidebar-nav-logo>

      <ng-container>
        @for(navConfig of upperNavMenuConfigs; track navConfig.id) {
        <app-infopost-sidebar-nav-item [id]="navConfig.id"
                                       [config]="navConfig"
                                       [menuItemType]="menuItemType"
                                       [menuGuards]="menuGuards">
        </app-infopost-sidebar-nav-item>
        }
      </ng-container>

    </div>
    <div>

      <ng-container>
        @for(navConfig of lowerNavMenuConfigs; track navConfig.id) {
        <app-infopost-sidebar-nav-item [id]="navConfig.id"
                                       [config]="navConfig">
        </app-infopost-sidebar-nav-item>
        }
      </ng-container>

      @if((menuItemType != CONST_LABELS.MENU_TYPE_INFOPOST && menuItemType != CONST_LABELS.MENU_TYPE_MAIN)) {
      <app-sidebar-nav-user [menuItemType]="menuItemType"></app-sidebar-nav-user>
      }

    </div>
  </div>
  @if(selectedPrimaryNavConfigHasSecondary) {
  <app-infopost-sidebar-nav-drawer (clickOutside)="clearSelectedPrimaryNavConfig()"
                                   [menuGuards]="menuGuards"
                                   [id]="(selectedPrimaryNavConfig?.id || 'hidden') + '-drawer'">
  </app-infopost-sidebar-nav-drawer>
  }
</app-sidebar-nav-container>
